import React from 'react'

const Loader = () => {
    return (
        <div className='loader_main'>
            <div className="loading">
                <div></div>
                <div></div>
            </div>
        </div>
    )
}

export default Loader